<template>
  <div class="boy_warphry">
    <div class="rkcz">
      <div>常住外来人口</div>
      <div class="twos">
        <div class="one">
          <span>{{datas.han+datas.qiTa}}</span><span>(人)</span>
          <div>常住外来人口</div>
        </div>
        <div class="one aa">
          <span>{{datas.han}}</span><span>(人)</span>
          <div>汉族</div>
        </div>
        <div class="one bb">
          <span>{{datas.qiTa}}</span><span>(人)</span>
          <div>其他</div>
        </div>
      </div>
    </div>
    <!-- <el-card> -->
    <div class="npm">
      <p>分民族地区的常住外来人口</p>
      <div ref="echartsINof" class="echarts" style="height: 40vh"></div>
    </div>
    <!-- </el-card> -->
  </div>
</template>

<script>
import { tj } from "@/network";
export default {
  data() {
    return {
      datas:{}
    };
  },
  created() {},
  mounted() {
    this.getInfoData();
    this.handEchart();
  },
  methods: {
    //jxq_mz
    async getInfoData() {
      const { code, data, msg } = await tj({
        tableName: "jxq_mz",
        // streetCode: "110105011",
      });
      this.datas=data[0]
      // console.log(data)
      let czrk = [];
      let villages_name = [];
      let han = [];
      let qiTa = [];
      for (const item of data) {
        czrk.push(item.czrk);
        villages_name.push(item.villages_name);
        han.push(item.han);
        qiTa.push(item.qiTa);
      }
      this.handEchart(czrk, villages_name,data[0].qiTa,data[0].han);
    },
    handEchart(e, es,qiTa,han) {
      let myechart = this.$echarts.init(this.$refs.echartsINof);
      let option = {
        backgroundColor: "rgba(20, 48, 99, 0)",
        tooltip: {
          formatter: "{b} : {c} ({d}%)",
        },

        // legend: {
        //   textStyle: {
        //     color: "#fff",
        //   },
        // },
        series: [
          {
            type: "pie",
            radius: "50%",
            data: [
              {
                value: han,
                name: "汉族",
              },
              {
                value: qiTa,
                name: "其他",
              },
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(20, 48, 99, 0.9)",
              },
            },
          },
        ],
      };
      myechart.setOption(option);
    },
  },
};
</script>

<style scoped lang="less">
.boy_warphry {
  background-color: rgba(20, 48, 99, 0);
  .npm {
    p {
      color: #fff;
      text-align: center;
      font-size: 18px;
      padding: 2vh;
    }
    .echarts {
      margin: 1vw;
    }
  }
}
.rkcz {
  div {
    color: #fff;
    text-align: center;
    margin-top: 2vh;
    font-size: 18px;
    margin-bottom: 2vh;
  }
  .twos {
    border: 1px solid #21517d;
    margin: 0 2vw;
    margin-bottom: 0.8vw;
    .one {
      display: inline-block;
      font-size: 18px;
      color: #fffd7d;
      padding-top: 1vh;
      span:nth-child(2) {
        font-size: 12px;
      }
      div {
        font-size: 12px;
        color: #fff;
        margin-top: 5px;
      }
    }
    .aa {
      border-top: 0;
      border-bottom: 0;
      padding: 0 2.5vw;
    }
  }
}
</style>
